module.exports = __webpack_public_path__ + "static/media/logo-turismo-pt-white.c1031b7d.svg";